<template>
    <el-dialog
        title="Delivery"
        :visible.sync="showForm"
        append-to-body
        :close-on-click-modal="false"
    >
        <div v-if="delivery">
            <div class="form-group">
                <label>ATS Integration</label>
                <select v-model="delivery.agent" class="form-control">
                    <option v-for="agent in agents" :value="agent.id">{{ agent.name }}</option>
                </select>
            </div>
            <component v-if="currentAgent && currentAgent.component" :is="currentAgent.component" :data="delivery.data"></component>

            <div class="form-group">
                <label>Campaign</label>
                <select v-model="delivery.campaign_id" class="form-control">
                    <option :value="null"> all campaigns </option>
                    <option v-for="campaign in campaigns" :value="campaign.id">{{ campaign.name }}</option>
                </select>
            </div>

            <div class="form-group">
                <label>Job</label><br />
                <el-select v-model="delivery.job_id" placeholder=" all jobs " style="width:100%">
                    <el-option :value="null"> all jobs </el-option>
                    <el-option v-for="job in jobs" 
                               :key="`jobselect-${job.id}`" 
                               :label="`${job.name} (${job.id})${job.admin_description ? ' - ' : ''}${job.admin_description}`"
                               :value="job.id">
                        {{ job.name }} ({{ job.id }})
                        <span v-if="job.admin_description" style="font-style: italic;">- {{ job.admin_description }}</span>
                    </el-option>
                </el-select>
            </div>

            <div class="form-group">
                <label>Lead Type</label><br>
                <el-checkbox v-model="delivery.is_sc">Direct leads</el-checkbox>
                <br>
                <el-checkbox v-model="delivery.is_mc">Multi-Carrier leads</el-checkbox>
                <br>
                <el-checkbox v-model="delivery.is_owner_operator">Owner Operators</el-checkbox>
                <br>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button type="danger" @click="remove" v-if="delivery_id">Delete</el-button>

            <el-button type="primary" @click="store">Save</el-button>
            <el-button @click="showForm = false">Close</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: [
        'show',
        'employer_id',
        'delivery_id',
        'agents'
    ],
    data() {
        return {
            order: null,
            delivery: null,
            loading: false,
            jobs: [],
            campaigns: []
        };
    },
    watch: {
        delivery_id() {
            this.refresh();
        }
    },
    computed: {
        showForm: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('close');
            }
        },
        currentAgent() {
            return _.find(this.agents, (r) => r.id == this.delivery.agent);
        }
    },
    methods: {
        store() {
            return axios.post(url(`admin/employer/${this.employer_id}/delivery/${this.delivery_id}`), {
                'delivery': this.delivery
            }).then(response => {
                this.showForm = false;
            });
        },
        remove() {
            return axios.post(url(`admin/employer/${this.employer_id}/delivery/${this.delivery_id}/delete`))
                .then(response => {
                    this.showForm = false;
                });
        },
        refresh() {
            if (!this.delivery_id) {
                this.delivery = {
                    'campaign_id': null,
                    'job_id': null,
                    'is_sc': true,
                    'is_mc': true,
                    'is_owner_operator': true,
                    'agent': null,
                    'data': {}
                };
                return;
            }

            this.loading = true;
            axios.get(url(`admin/employer/${this.employer_id}/delivery/${this.delivery_id}`))
                .then((response) => {
                    this.delivery = response.data;
                    this.loading = false;
                });
        }
    },
    created() {
        axios.get(url(`admin/employer/${this.employer_id}/jobs/dropdown`))
            .then((response) => {
                this.jobs = response.data;
            });
        axios.get(url(`admin/employer/${this.employer_id}/campaigns/dropdown`))
            .then((response) => {
                this.campaigns = response.data;
            });
    }
}
</script>

<style>
.cd-section {
    margin-top: 10px;
}
</style>
